import HeadingLevel, { type HeadingComponentType } from '../src/HeadingLevel';
export default HeadingLevel;
export type HeadingType = HeadingComponentType;
